import type { JSX } from 'react';
import { BariPostEnrollmentReadV1 } from '../v1/BariPostEnrollmentReadV1';

export function BariPostEnrollmentReadV2(): JSX.Element {
    return <BariPostEnrollmentReadV1 />;
}
